import React from "react";
import AboutArea from "../components/AboutArea";
import Breadcrumb from "../components/Breadcrumb";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import WhoWeAreArea from "../components/WhoWeAreArea";
import WorkProcess from "../components/WorkProcess";

const About = () => {
  return (
    <React.Fragment>
      <Navbar />
      <Breadcrumb title="aboutus" />
      <WhoWeAreArea />
      <AboutArea />
      <WorkProcess />
      <Footer />
    </React.Fragment>
  );
};

export default About;
